export default __webpack_public_path__ + "media/images/features/saga/zoom-6373dee4117a5c7b009df2df901813c0.png";